'use client';

import { useSyncExternalStore } from 'react';

const sinSuscripcion = () => () => {};

/**
 * `false` en el HTML del servidor y mientras React hidrata; `true` en cuanto
 * los manejadores del componente ya están conectados (y desde el primer
 * render en una navegación del cliente).
 *
 * Sirve para desactivar el envío de un formulario hasta que exista su
 * `onSubmit`: antes de hidratar, el navegador lo enviaría por su cuenta.
 */
export function useHidratado(): boolean {
  return useSyncExternalStore(sinSuscripcion, () => true, () => false);
}
